// extracted by mini-css-extract-plugin
export default {"title":"Navigation_title__zeIYO","navigationItem":"Navigation_navigationItem__WcOn0","navigation":"Navigation_navigation__xIjqU"};